import React, { ReactElement } from "react";
//#region types
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { KeyValue } from "models/utilTypes/keyValue";
import { TranslationKeys } from "translations";
import { CustomerDataProps } from "models/propTypes/customerPropTypes";
//#endregion
//#region components
import { Address, DetailsTableView } from "components/common";
import { useNavigate, useLocation } from "react-router-dom";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const CustomerDetails: React.FC<CustomerDataProps> = (props) => {
  const { customer } = props;

  const location = useLocation();
  const navigate = useNavigate();

  const getDetailsList = () => {
    const detailsList: Array<KeyValue<string, string | ReactElement> | typeof ACTION_SEPARATOR> = [
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.OrgOrPersonNumber),
        customer?.orgNumber ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Email),
        customer?.emailAddress ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Phone),
        customer?.phoneNumber ?? "-"
      ),
      ACTION_SEPARATOR,
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.InvoiceAddress),
        (
          <Address
            street1={customer?.billingAddress?.street1}
            street2={customer?.billingAddress?.street2}
            zipCode={customer?.billingAddress?.zipCode}
            city={customer?.billingAddress?.city}
            country={
              customer?.billingAddress?.countryCode
                ? LocalizationHelperInstance.getFormattedMessage(customer.billingAddress?.countryCode)
                : ""
            }
          ></Address>
        )
      ),
      ACTION_SEPARATOR,
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.PropertyDesignation),
        customer?.propertyDesignation ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.OrgNumberForBRF),
        customer?.tenantsOwnerAssociationOrgNumber ?? "-"
      ),
      new KeyValue(
        LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Customer.ApartmentNumber),
        customer?.apartmentNumber ?? "-"
      ),
    ];

    return detailsList;
  };

  const onClickAllInfo = () => {
    navigate(UrlHelper.formatPath(`/Customer/${customer?.id}/Settings`), {
      state: { background: location },
    });
  };

  return (
    <DetailsTableView
      detailsList={getDetailsList()}
      buttonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.AllInfo)}
      buttonOnClick={onClickAllInfo}
    ></DetailsTableView>
  );
};

export default CustomerDetails;
